export default "__VITE_ASSET__Bu9TAs1l__"